import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';
import { CompanyListItem } from '@/types/companies';
import { SVListItemCard } from '../core';
import { useGetUser } from '@/hooks/requests/useUser';

type CompaniesListProps = {
  companies: CompanyListItem[];
};

export default function CompaniesList({ companies }: CompaniesListProps) {
  const navigate = useNavigate();
  const { canSeeTeammates } = useGetUser();

  function buildManageMenuItems(uuid = '') {
    const manageMenuItems = [
      {
        label: 'Edit',
        onClick: () => navigate(`${ROUTES.COMPANIES_EDIT_PARAMS}/${uuid}`),
      },
      {
        label: 'Customers',
        onClick: () => navigate(`${ROUTES.CUSTOMERS}?company_id=${uuid}`),
      },
      {
        label: 'Businesses',
        onClick: () => navigate(`${ROUTES.BUSINESSES}?company_id=${uuid}`),
      },
    ];

    if (canSeeTeammates) {
      manageMenuItems.push({
        label: 'Teammates',
        onClick: () => navigate(`${ROUTES.TEAMMATES}?company_id=${uuid}`),
      });
    }

    return manageMenuItems;
  }

  return (
    <>
      {companies.map(companies => {
        const { uuid, status, name, aggregateNumbers } = companies;

        return (
          <SVListItemCard
            onClick={() => navigate(`${ROUTES.COMPANIES}/${uuid}`)}
            key={uuid}
            header={name}
            status={status}
            statusType="standard"
            manageMenuItems={buildManageMenuItems(uuid)}
            additionalInfo={[
              {
                label: 'Teammates',
                text: aggregateNumbers.teammates,
              },
              {
                label: 'Customers',
                text: aggregateNumbers.customers,
              },
              {
                label: 'Businesses',
                text: aggregateNumbers.businesses,
              },
              {
                label: 'Active Bank Accounts',
                text: aggregateNumbers.bank_accounts,
              },
              {
                label: 'Draft Bank Applications',
                text: aggregateNumbers.draftBankApplications,
              },
            ]}
          />
        );
      })}
    </>
  );
}
